import { TopNavigation } from '@components/TopNavigation';
import { LeftSidebar } from '@components/LeftSidebar';
import { useViewportScale } from '@hooks/useViewportScale';
import { useState, useCallback, useEffect, useRef } from 'react';
import { StyledBody, StyledContainer } from './style';

interface ControlPanelProps {
  children?: React.ReactNode;
}

export function ControlPanel({ children }: ControlPanelProps) {
  const viewport = useViewportScale();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(
    viewport.shouldAutoCollapseSidebar,
  );
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState<boolean>(false);
  const wasAutoCollapseSidebarRef = useRef(viewport.shouldAutoCollapseSidebar);

  useEffect(() => {
    const becameAutoCollapseSidebar =
      !wasAutoCollapseSidebarRef.current && viewport.shouldAutoCollapseSidebar;

    wasAutoCollapseSidebarRef.current = viewport.shouldAutoCollapseSidebar;

    if (becameAutoCollapseSidebar) {
      setIsSidebarCollapsed(true);
    }
  }, [viewport.shouldAutoCollapseSidebar]);

  useEffect(() => {
    if (!viewport.isMobile && !viewport.isTablet) {
      setIsMobileSidebarOpen(false);
    }
  }, [viewport.isMobile, viewport.isTablet]);

  // Abrir uma tela pelo menu lateral ou pela busca do topo recolhe a sidebar
  // para dar espaco ao conteudo; a reabertura manual continua disponivel.
  const handleShellNavigate = useCallback(() => {
    setIsSidebarCollapsed(true);
    setIsMobileSidebarOpen(false);
  }, []);

  const handleToggleSidebar = useCallback(() => {
    setIsSidebarCollapsed(prev => !prev);
  }, []);

  const handleToggleMobileSidebar = useCallback(() => {
    setIsMobileSidebarOpen(prev => !prev);
  }, []);

  const handleCloseMobileSidebar = useCallback(() => {
    setIsMobileSidebarOpen(false);
  }, []);

  return (
    <>
      <TopNavigation
        onMenuToggle={handleToggleMobileSidebar}
        onNavigate={handleShellNavigate}
      />
      <LeftSidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={handleToggleSidebar}
        isMobileOpen={isMobileSidebarOpen}
        onMobileClose={handleCloseMobileSidebar}
        onNavigate={handleShellNavigate}
      />
      <StyledContainer
        data-sidebar-collapsed={isSidebarCollapsed}
      >
        <StyledBody>{children}</StyledBody>
      </StyledContainer>
    </>
  );
}
